import { render, staticRenderFns } from "./InvoiceDate.vue?vue&type=template&id=b273f0cc&scoped=true"
import script from "./InvoiceDate.vue?vue&type=script&lang=js"
export * from "./InvoiceDate.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDate.vue?vue&type=style&index=0&id=b273f0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b273f0cc",
  null
  
)

export default component.exports